var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { ExactaAPI } from '../../api/exactaapi';
import { types as apiActionTypes, setUserInfo_AC, setUserProperties_AC } from '../actions/api';
import * as authActions from '../actions/auth';
import * as rootActions from '../actions/root';
import * as websocketAction from '../actions/websocket';
import { authenticateSelector } from '../selectors/authenticate';
var exactaAPI;
export var instantiateAPI = function (_a) {
    var payload = _a.payload, currentActionType = _a.type;
    return __generator(this, function (_b) {
        console.log('ex-mat-react', { currentActionType: currentActionType, payload: payload, exactaAPI: exactaAPI });
        if (!exactaAPI) {
            exactaAPI = new ExactaAPI(payload);
        }
        return [2];
    });
};
export var login = function (_a) {
    var login, password, app, _b, response, error, _c, token, userId, app_1, apps, applications, errorResponse;
    var payload = _a.payload, currentActionType = _a.type;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log({ currentActionType: currentActionType, payload: payload });
                return [4, put(authActions.authenticating_AC())];
            case 1:
                _d.sent();
                login = payload.login, password = payload.password, app = payload.app;
                return [4, call(exactaAPI.login, login, password, app)];
            case 2:
                _b = _d.sent(), response = _b.response, error = _b.error;
                console.log(currentActionType, { response: response, error: error });
                if (!response) return [3, 4];
                _c = response && response.data, token = _c.token, userId = _c.userId, app_1 = _c.app, apps = _c.apps;
                applications = apps || [app_1];
                return [4, put(authActions.loginSuccess_AC(token, userId, login, applications))];
            case 3:
                _d.sent();
                return [3, 8];
            case 4:
                errorResponse = error.errorResponse;
                if (!errorResponse) return [3, 6];
                return [4, put(authActions.loginError_AC(errorResponse))];
            case 5:
                _d.sent();
                return [3, 8];
            case 6: return [4, put(authActions.loginError_AC({}))];
            case 7:
                _d.sent();
                _d.label = 8;
            case 8: return [2];
        }
    });
};
var setAuthToken = function (_a) {
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        console.log(type, payload);
        exactaAPI.setAuthorizationHeader(payload.token);
        return [2];
    });
};
export var logout = function (_a) {
    var _b, response, error;
    var currentActionType = _a.type;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4, put(authActions.loggingOut_AC())];
            case 1:
                _c.sent();
                return [4, call(exactaAPI.logout)];
            case 2:
                _b = _c.sent(), response = _b.response, error = _b.error;
                return [4, put(websocketAction.closeSocket_AC())];
            case 3:
                _c.sent();
                console.log({ currentActionType: currentActionType, response: response, error: error });
                return [4, put(rootActions.resetState_AC())];
            case 4:
                _c.sent();
                return [2];
        }
    });
};
export var getUserInfo = function () {
    var userId, exactaApi, apiVersion, requests, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, select(authenticateSelector)];
            case 1:
                userId = (_a.sent()).userId;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                requests = [
                    {
                        type: 'processInstance',
                        version: apiVersion,
                        id: userId,
                        subscribe: false,
                        history: false,
                    },
                ];
                return [4, call(exactaApi.get, requests)];
            case 2:
                response = (_a.sent()).response;
                if (!response) return [3, 4];
                return [4, put(setUserInfo_AC(response.data.data[0]))];
            case 3:
                _a.sent();
                return [3, 5];
            case 4:
                console.log('error');
                _a.label = 5;
            case 5: return [2];
        }
    });
};
export var getUserProperties = function (_a) {
    var propertiesId, exactaApi, apiVersion, requests, response;
    var payload = _a.payload, type = _a.type;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                propertiesId = payload.propertiesId;
                exactaApi = ExactaAPI.getInstance();
                apiVersion = exactaApi.getApiVersion();
                requests = [
                    {
                        type: 'processInstance',
                        version: apiVersion,
                        id: propertiesId,
                        subscribe: false,
                        history: false,
                    },
                ];
                return [4, call(exactaApi.get, requests)];
            case 1:
                response = (_b.sent()).response;
                if (!response) return [3, 3];
                return [4, put(setUserProperties_AC(response.data.data[0]))];
            case 2:
                _b.sent();
                return [3, 4];
            case 3:
                console.log('error');
                _b.label = 4;
            case 4: return [2];
        }
    });
};
var actionWatcher = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, takeEvery(apiActionTypes.SET_AUTH_TOKEN, setAuthToken)];
            case 1:
                _a.sent();
                return [4, takeEvery(apiActionTypes.INSTANTIATE_API, instantiateAPI)];
            case 2:
                _a.sent();
                return [4, takeLatest(apiActionTypes.API_LOGIN, login)];
            case 3:
                _a.sent();
                return [4, takeLatest(apiActionTypes.API_LOGOUT, logout)];
            case 4:
                _a.sent();
                return [4, takeLatest(apiActionTypes.GET_USER_INFO, getUserInfo)];
            case 5:
                _a.sent();
                return [4, takeLatest(apiActionTypes.GET_USER_PROPERTIES, getUserProperties)];
            case 6:
                _a.sent();
                return [2];
        }
    });
};
export default actionWatcher;
//# sourceMappingURL=api.js.map